import { render, staticRenderFns } from "./CustomerArticles.vue?vue&type=template&id=e16043de&scoped=true&"
import script from "./CustomerArticles.vue?vue&type=script&lang=js&"
export * from "./CustomerArticles.vue?vue&type=script&lang=js&"
import style0 from "./CustomerArticles.vue?vue&type=style&index=0&id=e16043de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16043de",
  null
  
)

export default component.exports